import React, { useEffect, useState } from "react";
import PageContainer from "../../../themes/components/PageContainer";
import FeatureCard from "../components/FeatureCard";
import ComingSoonFeature from "../services/models/ComingSoonFeature";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import ErrorPage from "../../../common/pages/ErrorPage";
import useGetComingSoonFeatureService from "../services/api/GetComingSoonFeatureService";
import NotFound from "../../../common/pages/NotFound";
import { AccessPermissionContext } from "../../../providers/AccessPermissionsProvider";
import { useEnabledFeatureFlag } from "../../../common/feature-flagging/FeatureFlagProvider";
import FeatureFlags from "../../../common/feature-flagging/FeatureFlags";

type AuthenticatedComingSoonContentProps = {
  comingSoonVisible: boolean;
}

const AuthenticatedComingSoonContent = ({ comingSoonVisible }: AuthenticatedComingSoonContentProps): JSX.Element => {
  const [featureData, setFeatureData] = useState<
    ComingSoonFeature[] | ComingSoonFeature
  >([]);

  const { data, isLoading, isError, error } = useGetComingSoonFeatureService({
    populate: '[sort][0]=order%3Aasc"',
  });

  useEffect(() => {
    if (data?.data) {
      setFeatureData(data.data);
    }
  }, [data]);

  if (isLoading) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <ErrorPage errors={error} />;
  }

  if (!comingSoonVisible) {
    return <NotFound />;
  }

  return (
    <PageContainer>
      <div
        style={{
          borderTopWidth: "1px",
          borderTopStyle: "solid",
          borderTopColor: "#F2F2F2",
          paddingTop: "30px",
          marginTop: "110px",
        }}
      >
        <h2
          style={{
            fontSize: "25px",
            fontWeight: 700,
            lineHeight: "28px",
            letterSpacing: "0.16px",
            textTransform: "capitalize",
            color: "#ED7787",
            fontFamily: "Manrope, sans-serif",
            marginBottom: "0px",
          }}
        >
          Exciting New Features
        </h2>

        <h1
          style={{
            color: "#062133",
            fontSize: "30px",
            fontWeight: 700,
            textTransform: "uppercase",
            letterSpacing: "0.16px",
            marginTop: "6px",
            marginBottom: "0px",
          }}
        >
          COMING SOON!
        </h1>
        <p
          style={{
            marginTop: "8px",
            fontSize: "16px",
            fontWeight: 500,
            color: "#819099",
            fontFamily: "Manrope, sans-serif",
            lineHeight: "28px",
            letterSpacing: "0.16px",
            maxWidth: "900px",
          }}
        >
          Discover our latest and greatest! Introducing a host of exciting new
          and upcoming features that will elevate your experience to
          extraordinary heights. Stay tuned for innovation at its finest!
        </p>

        <div
          style={{
            display: "flex",
            justifyContent: "start",
            flexWrap: "wrap",
            gap: "38px",
            marginTop: "38px",
          }}
        >
          {featureData &&
            Array.isArray(featureData) &&
            featureData.map((feature) => (
              <FeatureCard key={feature.id} feature={feature} />
            ))}
        </div>
      </div>
    </PageContainer>
  );
};

const ComingSoonDirectory = (): JSX.Element => {
  const { hasPermissions } = React.useContext(AccessPermissionContext);
  const comingSoonVisible = useEnabledFeatureFlag(FeatureFlags.COMING_SOON as string);

  if (!hasPermissions) {
    return <NotFound />;
  }

  return <AuthenticatedComingSoonContent comingSoonVisible={comingSoonVisible} />;
};

export default ComingSoonDirectory;